import { definePreset } from '@primeng/themes';
import { ThemeConfigType } from 'primeng/config';
import Aura from '@primeng/themes/aura';
// import Lara from '@primeng/themes/lara'
// import Material from '@primeng/themes/material'
// import Nora from '@primeng/themes/nora'

export const MyPreset = definePreset(Aura, {
    semantic: {

        iconSize: "0.75rem",
        confirmDialogIconSize: "0.75rem",
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
        },
        primary: {
            50: "#f3f6f9",
            100: "#c5d4e0",
            200: "#98b2c8",
            300: "#6a91af",
            400: "#3d6f97",
            500: "#0f4d7e",
            600: "#0d416b",
            700: "#0b3658",
            800: "#082a45",
            900: "#061f32",
            950: "#041320"
        },
        formField: {
            paddingX: "0.70rem",
            paddingY: "0.45rem",
            sm: {
                fontSize: "0.75rem",
                paddingX: "0.70rem",
                paddingY: "0.45rem",
                height: "33px"
            },
            lg: {
                fontSize: "1.125rem",
                paddingX: "0.875rem",
                paddingY: "0.625rem"
            },
            borderRadius: "{border.radius.sm}",
            focusRing: {
                width: "0",
                style: "none",
                color: "transparent",
                offset: "0",
                shadow: "none"
            },
            transitionDuration: "{transition.duration}"
        },
    }
})

export let theme: ThemeConfigType = {
    theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: false || 'none'
        }
    }

}

export function setLightTheme() {
    console.log(theme)
    theme = {
        theme: {
            preset: MyPreset,
            options: {
                darkModeSelector: false || 'none'
            }
        }
    }
}